/* Smooth motion - scroll reveals + image fade-in.
   Progressive enhancement: nothing is hidden unless this script runs,
   and nothing already on screen at load is ever hidden. */
(function () {
  if (window.Shopify && Shopify.designMode) return; // keep the theme editor static
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var ITEM_SEL = [
    '.resource-list__item',
    '.product-grid__item',
    '.collection-list__item',
    '.blog-post-item',
  ].join(',');
  var SECTION_SEL = 'main > .shopify-section, main .shopify-section';
  var MAX_STAGGER = 6;
  var STEP_MS = 70;

  var pendingEls = new Set();

  function reveal(el) {
    if (!pendingEls.has(el)) return;
    pendingEls.delete(el);
    io.unobserve(el);
    el.classList.add('sm-in');
    // release the stagger delay after the animation
    setTimeout(function () {
      el.style.removeProperty('--sm-delay');
    }, 1200);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) reveal(e.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  var vh = window.innerHeight;

  function belowFold(el) {
    var r = el.getBoundingClientRect();
    // skip anything off to the side (carousel slides) so swiping never shows blanks
    if (r.right <= 0 || r.left >= window.innerWidth) return false;
    return r.top > vh * 0.92 && r.height > 0;
  }

  function mark(el, delay) {
    if (el.hasAttribute('data-sm-reveal')) return;
    if (!belowFold(el)) return; // visible now: never hide it
    el.setAttribute('data-sm-reveal', '');
    if (delay) el.style.setProperty('--sm-delay', delay + 'ms');
    pendingEls.add(el);
    io.observe(el);
  }

  // Safety net: if the observer ever misses (fast jumps, odd scroll
  // containers), reveal anything that is on screen after scrolling stops.
  var scrollTimer = null;
  document.addEventListener(
    'scroll',
    function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var h = window.innerHeight;
        pendingEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < h && r.bottom > 0) reveal(el);
        });
      }, 120);
    },
    { capture: true, passive: true }
  );

  function scan(scope) {
    // Grid items: staggered per row group
    var groups = new Map();
    scope.querySelectorAll(ITEM_SEL).forEach(function (item) {
      var parent = item.parentElement;
      var i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      mark(item, (i % MAX_STAGGER) * STEP_MS);
    });

    // Whole sections that don't contain grid items (story, banners, text)
    scope.querySelectorAll(SECTION_SEL).forEach(function (section, idx) {
      if (idx === 0) return; // never the first section (hero / LCP)
      if (section.querySelector(ITEM_SEL)) return;
      if (section.closest('[data-sm-reveal]')) return;
      mark(section, 0);
    });
  }

  function fadeImages(scope) {
    scope.querySelectorAll('main img[loading="lazy"]').forEach(function (img) {
      if (img.dataset.smImg) return;
      img.dataset.smImg = '1';
      if (img.complete && img.naturalWidth) return; // already there
      img.classList.add('sm-img-fade', 'sm-img-wait');
      var done = function () {
        img.classList.remove('sm-img-wait');
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(done, 4000); // never leave an image hidden
    });
  }

  function init() {
    root.classList.add('sm-js');
    var main = document.getElementById('MainContent') || document.body;
    scan(main);
    fadeImages(main);

    // Infinite scroll / filters / recommendations add content later
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        vh = window.innerHeight;
        scan(main);
        fadeImages(main);
      });
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Back/forward cache: show everything immediately
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-sm-reveal]').forEach(function (el) {
      el.classList.add('sm-in');
    });
  });
})();
